import { render, staticRenderFns } from "./FormProductAdditionalFee.vue?vue&type=template&id=0f226495&scoped=true&"
import script from "./FormProductAdditionalFee.vue?vue&type=script&lang=js&"
export * from "./FormProductAdditionalFee.vue?vue&type=script&lang=js&"
import style0 from "./FormProductAdditionalFee.vue?vue&type=style&index=0&id=0f226495&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f226495",
  null
  
)

export default component.exports